import { Button } from '@ordr-as/umami-react/button';
import { memo, useCallback, useState } from 'react';
import { PaymentMethodDto } from '../../../../../../generated-api';
import PaymentButtonStatus from '../../../../DigitalBill/unsettled/sidebar/payment/OpenBillCheckout/PaymentButtons/PaymentButtonStatus';
import TerminalDiagnosisDialog from './TerminalDiagnosisDialog/TerminalDiagnosisDialog';
import { TerminalDisplayState } from '../../../../../context/PaymentMethodStore';
import Spinner from '../../../../../components/Spinner';
import classNames from 'classnames';

interface Props {
  paymentMethod: PaymentMethodDto;
  terminalState: TerminalDisplayState;
  paymentLoading: boolean;
  className: string;
  onClick: () => void;
  onTryAnyway: () => void;
  canTryPaymentAnyway: boolean;
}

const IntegratedTerminalPaymentButton = (props: Props) => {
  const { paymentMethod, terminalState, paymentLoading, className, onClick, onTryAnyway, canTryPaymentAnyway } = props;
  const [dialogIsOpen, setDialogIsOpen] = useState(false);

  const handleClick = useCallback(() => {
    if (paymentLoading) {
      // Still clickable — lets the parent open the active-payment cancel dialog.
      onClick();
      return;
    }

    if (terminalState === 'OFFLINE') {
      setDialogIsOpen(true);
      return;
    }

    // For BUSY and any other non-AVAILABLE state, route to parent.
    // Parent will open the cancel dialog if there's an active payment,
    // or block re-initiation otherwise.
    onClick();
  }, [paymentLoading, terminalState, onClick]);

  const classes = classNames(className, {
    'opacity-75': terminalState === 'BUSY',
  });

  return (
    <>
      <Button className={classes} kind={'primary'} onClick={handleClick}>
        {paymentLoading ? <Spinner className="w-4 h-4" /> : <PaymentButtonStatus terminalState={terminalState} />}
        <div className="truncate-2">{paymentMethod.label}</div>
      </Button>
      {dialogIsOpen && (
        <TerminalDiagnosisDialog
          terminalName={paymentMethod.label}
          onCloseDialog={() => setDialogIsOpen(false)}
          onTryPayment={onTryAnyway}
          canTryPaymentAnyway={canTryPaymentAnyway}
          pspTerminalId={paymentMethod.id}
        />
      )}
    </>
  );
};

export default memo(IntegratedTerminalPaymentButton);
